export const service_package = {
  table: {
    field: {
      name: 'Name',
      subscription_fee: 'Subscription fee',
      contact_count: 'Contact count',
      contact_method_count: 'Contact methods count',
      ivr_count: 'IVR count',
      estimate: 'Estimate',
      record: 'Call recording',
      disk_space_mb: 'Disk space (MB)',
      sip_account_with_caller_id_count: 'Count of SIP accounts for outgoing calls'
    }
  },

  modal: {
    change: {
      content: 'Are you sure you want to connect the service package {name} for the Virtual PBX?',
      buttons: {
        ok: 'Toggle'
      }
    },

    change_time: {
      title: 'Change PBX package now?',
      content: 'You can change the PBX package now or at the end of the current package',
      buttons: {
        immediate: 'Change now',
        deferred: 'Change at {date}'
      }
    }
  },

  card: {
    cost: '{cost} per month',
    connect: 'Connect',
    connected: 'Connected',
    unlimited: 'Unlimited'
  },

  limit: {
    record: 'Call records are not available for your PBX package',
    contacts: 'The maximum number of contacts has been created for your PBX service package',
    contact_methods: 'Added maximum number of contact methods provided by your PBX package',
    ivr: 'The maximum number of IVRs has been created for your PBX package'
  }
};
